
import {Observable} from "rxjs";
import {MatchPlayer} from "@app/core/match-player/domain/model/match-player";


export abstract class MatchPlayerRepo {
    abstract searchUsers(email: string): Observable<MatchPlayer[]>;
}
